import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para cualquier nicho?',
  a: 'Sí. Cosméticos, ropa, accesorios, bijoutería, alimentos, productos digitales y más. Todo es adaptable a tu producto y tu cliente.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís el acceso por email. En menos de 5 minutos podés estar leyendo el Tomo 1. Sin apps. Funciona en teléfono, tablet y computadora.'
}, {
  q: '¿Funciona si recién empiezo?',
  a: 'Especialmente si empezás. El Bono 1 tiene el mapa desde cero. El Bono 6 resuelve el miedo a grabar. Los 6 tomos están en orden para que sigas el sistema paso a paso.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, devolución completa. Sin justificaciones. Escribís a soportebibliotecasdigitales@gmail.com y listo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full py-12 px-4 bg-base" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <div className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-extrabold text-text-main flex items-center justify-center gap-3" data-id="element-80">
            <span data-id="element-81">❓</span> PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-alt border-primary/40' : 'bg-alt/50 border-primary/10'}`} data-id="element-83">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-84">
                  <span className={`font-bold text-lg ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-85">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-text-muted transition-transform duration-300 ${isOpen ? 'rotate-180 text-primary' : ''}`} data-id="element-86" />
                </button>
                <AnimatePresence data-id="element-87">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-88">
                      <div className="px-6 pb-5 text-text-muted leading-relaxed" data-id="element-89">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}